import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { BehaviorSubject, Subscription } from "rxjs";
import {
  EasyLinkAttemptData,
  selectEmployeeBenefitsEasylinkPipeline,
  setEmployeeBenefitsEasylinkPipeline,
} from "src/app/core/ngrx/ui";
import { Store } from "@ngrx/store";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import {
  clearlinkEasySignup,
  linkEasySignup,
  selectAccount,
  selectLinkEasySignup,
} from "src/app/core/ngrx/myqq";
import { LinkEasySignupToB2BRequest } from "src/app/core/services/myqq/myqq.models";

@Component({
  selector: "myqq-add-employee-id-page",
  templateUrl: "./add-employee-id.page.html",
  styleUrls: ["./add-employee-id.page.scss"],
})
export class AddEmployeeIdModalPage implements OnInit {
  subs: Subscription[] = [];
  hasMembership$ = new BehaviorSubject<boolean>(true);
  employeeIdLength = 10;
  employeeBenefitsData;
  employeeIdInput = new FormControl("", [
    Validators.minLength(this.employeeIdLength),
  ]);
  showSecondChanceOptInButton = false;

  constructor(
    private store$: Store<any>,
    readonly router: Router,
    readonly http: HttpClient
  ) {}

  readonly account$ = this.store$.select(selectAccount);
  readonly linkEasySignup$;

  ngOnInit() {
    this.subs.push(
      this.store$
        .select(selectEmployeeBenefitsEasylinkPipeline)
        .subscribe((pipelineData) => {
          this.employeeBenefitsData = { ...pipelineData };
        })
    );
    this.subs.push(
      this.store$.select(selectLinkEasySignup).subscribe((data) => {
        if (data?._tag === "Replete") {
          if (data?.value?._tag === "Right") {
            this.handleSuccess();
          } else {
            this.handleError();
          }
        }
      })
    );
  }

  handleSubmit(employeeID: any, userAccount: any) {
    const userAccountData = userAccount.value?.right;
    if (userAccountData) {
      const requestBody: LinkEasySignupToB2BRequest = {
        linkId: this.employeeBenefitsData.linkid,
        personId: userAccountData.personId,
        businessId: this.employeeBenefitsData.businessId,
        contractId: this.employeeBenefitsData.contractId,
        firstName: userAccountData.firstName,
        lastName: userAccountData.lastName,
        workEmail: userAccountData.email,
        employeeId: employeeID,
      };
      this.store$.dispatch(linkEasySignup.pending(requestBody));
    } else {
      this.handleError();
    }
  }

  handleCancel() {
    const linkAttemptData: EasyLinkAttemptData = {
      ...this.employeeBenefitsData.linkAttemptData,
    };
    this.setEmployeeBenefitsEaslyLinkPipelineData(linkAttemptData, true);
    this.close();
  }

  handleSuccess() {
    const easyLinkAttemptData: EasyLinkAttemptData = {
      showLinkAttemptData: true,
      isLinkingSuccess: true,
    };

    this.setEmployeeBenefitsEaslyLinkPipelineData(easyLinkAttemptData, false);
    this.close();
  }

  handleError() {
    const easyLinkAttemptData: EasyLinkAttemptData = {
      showLinkAttemptData: true,
      isLinkingSuccess: false,
    };
    this.setEmployeeBenefitsEaslyLinkPipelineData(easyLinkAttemptData, true);
    this.store$.dispatch(clearlinkEasySignup(null));
    this.close();
  }

  close() {
    this.router.navigateByUrl("/purchase");
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

  setEmployeeBenefitsEaslyLinkPipelineData(
    linkAttemptData: EasyLinkAttemptData,
    showEmployeeBenefitsOptIn
  ) {
    this.store$.dispatch(
      setEmployeeBenefitsEasylinkPipeline({
        ...this.employeeBenefitsData,
        isInitialModal: false,
        linkAttemptData,
        showEmployeeBenefitsOptIn,
      })
    );
  }
}
